// Languages offered in menu language sub-menus (mirrors ModalLanguages). `code` is
// the i18next language code; `native` is the label shown in the list.
export const LANGUAGES = [
    { code: 'en', native: 'English' },
    { code: 'fr', native: 'Français' },
    { code: 'de', native: 'Deutsch' },
    // { code: 'hi', native: 'हिंदी' },
    { code: 'id', native: 'Indonesia' },
    { code: 'it', native: 'Italiano' },
    { code: 'ja', native: '日本語' },
    { code: 'ko', native: '한국어' },
    // { code: 'pl', native: 'Polski' },
    { code: 'pt-BR', native: 'Português' },
    // { code: 'zh-CN', native: '简体中文' },
    { code: 'es', native: 'Español' },
    // { code: 'th', native: 'ภาษาไทย' },
    // { code: 'zh-TW', native: '繁體中文' },
    // { code: 'tr', native: 'Türkçe' },
    { code: 'vi', native: 'Tiếng Việt' },
];
